import React from "react";
import { PhoneButton, PHONE } from "./PhoneButton";

export const StickyMobileCTA = () => {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] shadow-[0_-6px_20px_rgba(0,0,0,0.08)]"
    >
      <PhoneButton
        size="md"
        fullWidth
        testId="sticky-mobile-call-button"
        label={`Call ${PHONE.display}`}
      />
      <p className="mt-2 text-center text-xs text-slate-600">
        Speak to a licensed agent • Free quote
      </p>
    </div>
  );
};
